import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./UserNotEnabled.scss";

export function UserNotEnabled() {
  const [t] = useTranslation();

  return (
    <div className="user-not-enabled-page trans-fromTop">
      <span className="title">{t("UserNotEnabled")}</span>
      <span className="subtitle">{t("UserNotEnabledDescription")}</span>
    </div>
  );
}
